// LRT Search Engines: the engines a report can track, by the id the API uses
export const LRT_SEARCH_ENGINE = {
  GOOGLE: 'google',
  GOOGLE_MOBILE: 'google-mobile',
  GOOGLE_LOCAL_PACK: 'google-local-pack',
  GOOGLE_PLACES: 'google-places',
  BING: 'bing',
  BING_LOCAL_PACK: 'bing-local-pack'
} as const;

// LRT Report Run Statuses: the outcome of one update in the report history
export const LRT_RUN_STATUS = {
  SUCCESSFUL: 'successful',
  FAILED: 'failed'
} as const;

// LRT Position Ranges: the brackets a run counts its keywords in; `21-50` only on depth-50 reports
export const LRT_POSITION_RANGE = {
  TOP: '1',
  TWO_TO_FIVE: '2-5',
  SIX_TO_TEN: '6-10',
  ELEVEN_TO_TWENTY: '11-20',
  TWENTY_ONE_TO_FIFTY: '21-50',
  NOT_RANKING: 'not_ranking'
} as const;
